export default "__VITE_ASSET__GBT647I9__"